import { Action } from '@ngrx/store';
import { SearchHistoryItem } from '@search/const';

export const SEARCH_HISTORY_PUSH = '[Search] Search History Push';
export const SEARCH_HISTORY_REMOVE = '[Search] Search History Remove';
export const SEARCH_HISTORY_RESET = '[Search] Search History Reset';
export const SEARCH_HISTORY_SET_STATE = '[Search] Search History Set State';

export class SearchHistoryPush implements Action {
  readonly type = SEARCH_HISTORY_PUSH;

  constructor(public payload: SearchHistoryItem) {}
}

export class SearchHistoryRemove implements Action {
  readonly type = SEARCH_HISTORY_REMOVE;

  constructor(public payload: SearchHistoryItem) {}
}

export class SearchHistoryReset implements Action {
  readonly type = SEARCH_HISTORY_RESET;
}

export class SearchHistorySetState implements Action {
  readonly type = SEARCH_HISTORY_SET_STATE;

  constructor(public payload: SearchHistoryItem[]) {}
}

export type SearchHistoryAction = SearchHistoryPush | SearchHistoryRemove | SearchHistoryReset | SearchHistorySetState;
